/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";

import { useGetStoresByRegionalQuery } from "@/services/store/select-options";
import SingleSelect from "components/input-select-store";
import { useFilterActions } from "../../ducks/filter/hooks/actions";
import { toast } from "components/ui/use-toast";

export default function StoreFilter() {
  const { updateFilter } = useFilterActions();
  const { data, error } = useGetStoresByRegionalQuery();

  useEffect(() => {
    if (!error) {
      return;
    }

    const errorMessage =
      (error as any)?.data?.messages?.[0] ||
      (error as any)?.data?.message ||
      "Erro ao buscar o saldo. Tente novamente.";

    toast({
      description: errorMessage,
      variant: "destructive",
    });
  }, [error]);
    const storeOptions =
    data?.lojas.map((loja) => ({
      value: loja.toString(),
      label: `Loja ${loja}`,
    })) || [];

  const handleSelectStoreChange = (
    option: { value: string; label: string } | undefined
  ) => {
    if (option?.value) {
      updateFilter({ key: "code", value: option.value });
      updateFilter({ key: "meta", value: { page: 1 } });
    } else {
      updateFilter({ key: "code", value: null });
      updateFilter({ key: "name", value: null });
    }
  };

  return (
    <SingleSelect
      label="Loja"
      options={storeOptions}
      placeholder="Selecionar loja"
      onChange={handleSelectStoreChange}
    />
  );
}
